module.exports = __webpack_public_path__ + "static/media/puzzle-33-bg.f702f38b.svg";